import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-control-1-6-0{display:block;position:relative;width:100%;margin-bottom:24px}.hcr-control--is-last-1-6-0{margin-bottom:0}.hcr-control--small-1-6-0{width:50%}",
map:{"hcr-control":"hcr-control-1-6-0","hcr-control--is-last":"hcr-control--is-last-1-6-0","hcr-control--small":"hcr-control--small-1-6-0"}};

var bem = Bem('control', styles);
var FormControl = function FormControl(_ref) {
  var extraClasses = _ref.extraClasses,
      children = _ref.children,
      small = _ref.small,
      last = _ref.last,
      rest = _objectWithoutProperties(_ref, ["extraClasses", "children", "small", "last"]);

  var formControlClassNames = bem.b({
    small: small,
    'is-last': last
  }, extraClasses);
  return React.createElement("div", _extends({
    className: formControlClassNames
  }, rest), children);
};
FormControl.displayName = 'FormControl';
FormControl.defaultProps = {
  extraClasses: '',
  small: false,
  last: false
};
FormControl.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Children are required */
  children: PropTypes.node.isRequired,

  /** Decreases the width of the form row to 50% */
  small: PropTypes.bool,

  /** Removes bottom margins, might be useful for the very bottom rows */
  last: PropTypes.bool
};
var formControl = Injecss(FormControl, styles);

export { formControl as FormControl };
